import { useState } from 'react';
import { BRAND } from '@app/shared/core';
import { api } from '../api';
import { Logo } from '../brand/Logo';
import { platform } from '../platform';
import { useApp } from '../state';
import { Icon } from '../ui';

/** Вход закрыт: человека нет в списке сотрудников или доступ заблокирован. */
export function Access() {
  const { me, reloadMe, toast } = useApp();
  const [busy, setBusy] = useState(false);
  const blocked = me.employee?.status === 'blocked';

  async function byPhone() {
    setBusy(true);
    try {
      const ok = await platform.requestContact();
      if (!ok) return toast('Номер не отправлен');
      // Контакт уходит боту, бот ищет номер в списке — даём ему пару секунд.
      for (let i = 0; i < 6; i++) {
        await new Promise((r) => setTimeout(r, 1200));
        const m = await api.me().catch(() => null);
        if (m?.employee?.status === 'active') return void (await reloadMe());
      }
      toast('Этого номера нет в списке. Передайте администратору ваш ID.');
    } finally {
      setBusy(false);
    }
  }

  async function copyId() {
    try {
      await navigator.clipboard.writeText(String(me.user.id));
      toast('ID скопирован');
    } catch {
      toast(`Ваш ID: ${me.user.id}`);
    }
  }

  return (
    <main className="app">
      <div className="stack lg" style={{ paddingTop: 8 }}>
        <section className="hero-dark">
          <Logo height={15} />
          <h1 className="h1" style={{ fontSize: 26 }}>
            Цех
          </h1>
          <p>{BRAND.tagline[0]!.toUpperCase() + BRAND.tagline.slice(1)}: панели оборудования, задачи смены, справка по наладке.</p>
        </section>

        {blocked ? (
          <section className="warn-card stack">
            <h2 className="h2">Доступ закрыт</h2>
            <p style={{ margin: 0 }}>Администратор закрыл вам доступ. Если это ошибка — обратитесь к руководителю.</p>
          </section>
        ) : (
          <section className="card stack">
            <div className="row">
              <span className="mark">
                <Icon name="lock" />
              </span>
              <h2 className="h2 grow">Вход только для сотрудников из списка</h2>
            </div>
            <p style={{ margin: 0 }}>Администратор добавляет сотрудников по Telegram ID, @username или номеру телефона.</p>
            <div className="card flat row" style={{ gap: 8 }}>
              <span className="grow">
                <span className="small" style={{ display: 'block' }}>
                  Ваш Telegram ID
                </span>
                <b style={{ fontSize: 18 }}>{me.user.id}</b>
              </span>
              <button type="button" className="btn btn-ghost btn-sm" onClick={() => void copyId()}>
                Скопировать
              </button>
            </div>
            {platform.canRequestContact() && (
              <button type="button" className="btn btn-primary btn-block" disabled={busy} onClick={() => void byPhone()}>
                Войти по номеру телефона
              </button>
            )}
            <button type="button" className="btn btn-outline btn-block" disabled={busy} onClick={() => void reloadMe()}>
              Меня добавили — проверить
            </button>
          </section>
        )}
      </div>
    </main>
  );
}
